interface SpyCleanLogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
}

export default function SpyCleanLogo({
  className = "",
  width = 200,
  height = 54,
  alt = "Spy Clean GmbH - Perfekt bis ins Detail",
}: SpyCleanLogoProps) {
  return (
    <img
      src="https://vibe.filesafe.space/1782488784546330869/attachments/4581bae1-25de-4c23-ad24-ef156288a6e1.png"
      alt={alt}
      width={width}
      height={height}
      className={`object-contain bg-transparent ${className}`}
      style={{
        display: "block",
        background: "transparent",
        mixBlendMode: "multiply",
        filter: "brightness(1.05)",
      }}
      fetchPriority="high"
      loading="eager"
      decoding="sync"
    />
  );
}
